<template>
  <vue-markdown>{{ $store.getters.activeTopic.content }}</vue-markdown>
</template>

<script>
import VueMarkdown from 'vue-markdown'
export default {
  name: 'TopicContent',
  components: {
    VueMarkdown
  }
}
</script>

<style scoped>

</style>
